import React from 'react';

import {useSelector} from 'react-redux';
import {PopoverBody} from 'reactstrap';

import {useCurrentUserState} from 'app/current-user/api';
import {AttachOverlay, PopoverForm} from 'app/general/overlays';
import {useCreateLane} from 'app/lanes/api';
import {ManageLanesModal} from 'app/lanes/components/ManageLanesModal';
import {ApplyStepShaperFuncType} from 'app/steps/document-shaper';
import {gt} from 'app/utils/i18n';

import {LaneSelect} from './LaneSelect';

import {LaneSerializedType} from 'sweet-types';

interface Props {
  ct?: 'procedure' | 'process';
  stepLaneId?: string | null;
  applyStepShaper: ApplyStepShaperFuncType;
}

export function SetStepLaneButton({stepLaneId, applyStepShaper}: Props) {
  const [createLane] = useCreateLane();

  const stepLane = useSelector((store): LaneSerializedType | null =>
    stepLaneId != null ? store.lanes.byId[stepLaneId] : null
  );

  const {is_super_manager} = useCurrentUserState().data!;

  function setStepLane(lane: LaneSerializedType | null, close: () => void) {
    applyStepShaper((stepShaper) => stepShaper.setLane(lane).procedure(), true);
    close();
  }

  const [showManageModal, setShowManageModal] = React.useState(false);

  return (
    <>
      <AttachOverlay
        trigger="click legacy"
        overlay={({overlayProps}) => (
          <PopoverForm overlayProps={{...overlayProps, placement: 'bottom'}}>
            {({close}) => (
              <PopoverBody style={{width: 274}}>
                {is_super_manager ? (
                  <div className="text-right">
                    <button
                      className="btn btn-sm btn-link pt-0"
                      onClick={() => {
                        overlayProps.toggle();
                        setShowManageModal(true);
                      }}
                    >
                      {gt('Manage lanes')}
                    </button>
                  </div>
                ) : null}
                <LaneSelect
                  value={stepLane}
                  onChange={(lane: LaneSerializedType) =>
                    setStepLane(lane, close)
                  }
                  onCreateLane={(name: string) =>
                    createLane({name})
                      .unwrap()
                      .then((lane: LaneSerializedType) => {
                        setStepLane(lane, close);
                        return Promise.resolve(true);
                      })
                  }
                />
              </PopoverBody>
            )}
          </PopoverForm>
        )}
      >
        {(handlers) => (
          <button className="btn btn-sm btn-outline-primary" {...handlers}>
            <div className="d-flex align-items-center justify-content-center">
              {stepLane == null ? (
                gt('Set Step Lane')
              ) : (
                <>
                  {stepLane.name} <i className="fas fa-road mt-1 ml-1" />
                </>
              )}
            </div>
          </button>
        )}
      </AttachOverlay>
      <ManageLanesModal
        show={showManageModal}
        onClose={() => setShowManageModal(false)}
      />
    </>
  );
}
